import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
    FiChevronLeft,
    FiChevronRight,
    FiChevronsLeft,
    FiChevronsRight
} from "react-icons/fi";

import { fetchProductsAction } from "../../../../utils/redux/product/productActions";
import { getCategoryList } from "../../../../utils/api-service/get-services";

const ProductListingPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {
        products,
        isLoading,
        pagination
    } = useSelector(state => state.product);

    const [filters, setFilters] = useState({
        search: "",
        category: "",
        sortBy: "createdAt",
        sortOrder: "desc",
        page: 1,
        limit: 24
    });

    const [categories, setCategories] = useState([]);

    const [page, setPage] = useState(1);
    const limit = 24;

    useEffect(() => {
        const loadCategories = async () => {
            const categoriesRes = await getCategoryList();

            if (categoriesRes.success) {
                const parentCategories =
                    categoriesRes.tree.filter(
                        cat => cat.level === 0
                    );

                setCategories(parentCategories);
            }
        };

        loadCategories();
    }, []);


    useEffect(() => {
        const params = {
            ...filters
        };

        dispatch(fetchProductsAction(params));
    }, [dispatch, filters]);


    const onPageChange = (newPage) => {
        setFilters(prev => ({
            ...prev,
            page: newPage
        }));
    };

    const handleFilterChange = (key, value) => {

        setFilters(prev => ({
            ...prev,
            [key]: value,
            page: 1
        }));

    };


    const renderPagination = () => {
        if (!pagination || pagination.totalPages <= 1) {
            return null;
        }

        const {
            totalPages
        } = pagination;


        return (
            <div className="d-flex justify-content-center align-items-center gap-2 py-3">

                <button
                    onClick={() => onPageChange(1)}
                    disabled={filters.page === 1}
                    className="btn btn-sm btn-outline-secondary"
                >
                    <FiChevronsLeft />
                </button>


                <button
                    onClick={() => onPageChange(filters.page - 1)}
                    disabled={filters.page === 1}
                    className="btn btn-sm btn-outline-secondary"
                >
                    <FiChevronLeft />
                </button>


                <span className="px-3">
                    Page {filters.page} of {pagination.totalPages}
                </span>


                <button
                    onClick={() => onPageChange(filters.page + 1)}
                    disabled={filters.page === pagination.totalPages}
                    className="btn btn-sm btn-outline-secondary"
                >
                    <FiChevronRight />
                </button>


                <button
                    onClick={() => onPageChange(pagination.totalPages)}
                    disabled={filters.page === pagination.totalPages}
                    className="btn btn-sm btn-outline-secondary"
                >
                    <FiChevronsRight />
                </button>

            </div>
        );
    };


    return (
        <div className="container-fluid py-4">

            <div className="d-flex justify-content-between align-items-center mb-4">

                <h3>
                    Products
                </h3>

                <button
                    className="btn btn-primary"
                    onClick={() => navigate("/create-product")}
                >
                    + Add Product
                </button>

            </div>

            <div className="card mb-3">

                <div className="card-body">

                    <div className="row g-3">


                        {/* SEARCH */}
                        <div className="col-md-4">

                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search product..."
                                value={filters.search}
                                onChange={(e) =>
                                    handleFilterChange(
                                        "search",
                                        e.target.value
                                    )
                                }
                            />

                        </div>



                        {/* CATEGORY */}
                        <div className="col-md-3">

                            <select
                                className="form-select"
                                value={filters.category}
                                onChange={(e) =>
                                    handleFilterChange(
                                        "category",
                                        e.target.value
                                    )
                                }
                            >

                                <option value="">
                                    All Categories
                                </option>


                                {categories?.map(cat => (

                                    cat.children?.length ? (

                                        <optgroup
                                            key={cat._id}
                                            label={cat.name}
                                        >

                                            {cat.children?.map(child => (

                                                <option
                                                    key={child._id}
                                                    value={child._id}
                                                >
                                                    {child.name}
                                                </option>

                                            ))}

                                        </optgroup>


                                    ) : (

                                        <option
                                            key={cat._id}
                                            value={cat._id}
                                        >
                                            {cat.name}
                                        </option>

                                    )

                                ))}


                            </select>

                        </div>



                        {/* SORT */}
                        <div className="col-md-2">


                            <select
                                className="form-select"
                                value={`${filters.sortBy}-${filters.sortOrder}`}
                                onChange={(e) => {

                                    const [sortBy, sortOrder] =
                                        e.target.value.split("-");


                                    setFilters(prev => ({
                                        ...prev,
                                        sortBy,
                                        sortOrder,
                                        page: 1
                                    }));

                                }}
                            >

                                <option value="createdAt-desc">
                                    Newest
                                </option>

                                <option value="createdAt-asc">
                                    Oldest
                                </option>


                                <option value="name-asc">
                                    Name A-Z
                                </option>


                                <option value="name-desc">
                                    Name Z-A
                                </option>


                            </select>


                        </div>


                    </div>

                </div>

            </div>


            <div className="card">

                <div className="card-body p-0">


                    {isLoading ? (

                        <div className="p-4 text-center">
                            Loading products...
                        </div>

                    ) : products?.length === 0 ? (

                        <div className="p-4 text-center">
                            No products found
                        </div>

                    ) : (

                        <div className="table-responsive">

                            <table className="table table-hover mb-0">

                                <thead className="table-light">

                                    <tr>
                                        <th>Name</th>
                                        <th>Code</th>
                                        <th>Category</th>
                                        <th>Status</th>
                                        <th className="text-end">
                                            Actions
                                        </th>
                                    </tr>

                                </thead>


                                <tbody>

                                    {products?.map(product => (

                                        <tr key={product._id}>


                                            <td>

                                                <span
                                                    style={{
                                                        cursor: "pointer"
                                                    }}
                                                    onClick={() =>
                                                        navigate(
                                                            `/product/${product._id}`
                                                        )
                                                    }
                                                >
                                                    {product.name}
                                                </span>

                                            </td>


                                            <td>
                                                {product.code}
                                            </td>


                                            <td>
                                                {product.category?.name || "—"}
                                                {" "}
                                                {product.category?.parent?.name}
                                            </td>


                                            <td>

                                                <span
                                                    className={`badge ${product.status === "COMPLETED"
                                                        ? "bg-success"
                                                        : "bg-warning text-dark"
                                                        }`}
                                                >
                                                    {product.status}
                                                </span>

                                            </td>


                                            <td className="text-end">

                                                <button
                                                    className="btn btn-sm btn-outline-primary me-2"
                                                    onClick={() =>
                                                        navigate(
                                                            `/products/${product._id}/edit`
                                                        )
                                                    }
                                                >
                                                    Edit
                                                </button>


                                                <button
                                                    className="btn btn-sm btn-outline-danger"
                                                >
                                                    Delete
                                                </button>

                                            </td>


                                        </tr>

                                    ))}

                                </tbody>

                            </table>

                        </div>

                    )}


                    {renderPagination()}


                </div>

            </div>


        </div>
    );
};


export default ProductListingPage;